import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
	locales: ['ca', 'es', 'en'],
	defaultLocale: 'ca',
	localeDetection: false,
	localePrefix: 'as-needed',
});

export const { Link, redirect, usePathname, useRouter } =
	createNavigation(routing);
